import React, { useState, useEffect } from 'react'
import './FileDetails.css'
import LocalAidProfileComp from '../../LocalAidMainPage/localAidProfilePage/localAidProfileComp/LocalAidProfileComp'
import icon1 from '../../../assets/family name.png'
import icon2 from '../../../assets/nation id.png'
import icon3 from '../../../assets/gender.png'
import icon4 from '../../../assets/date of birth.png'
import icon5 from '../../../assets/ntionality.png'
import icon6 from '../../../assets/edducation.png'
import icon7 from '../../../assets/family name.png'
import icon8 from '../../../assets/mobile number.png'
import icon9 from '../../../assets/profile 2.png'
import { useTranslation } from "react-i18next";
import { getVoulnteerFile } from '../../../actions/volunteer'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import Loading from '../../ui/loading'
import ShareHeader from '../../LoaclComponents/shareHeader/ShareHeader'


const FileDetals = () => {
    const { t } = useTranslation();
    let lng = JSON.parse(localStorage.getItem('language'))?.lang;
    let userLogin = JSON.parse(localStorage.getItem('userLogin'))
    const dispatch = useDispatch()
    useEffect(() => {
        if (userLogin?.Results[0]?.vln_id_flag === '2') {
            if (lng === 'arab') {
                dispatch(getVoulnteerFile(userLogin?.Results[0]?.vln_id, 1))
            } else {
                dispatch(getVoulnteerFile(userLogin?.Results[0]?.vln_id, 2))
            }
        }
    }, [lng]);

    const vlnFileDteails = useSelector(state => state.vlnFileDteails.vlnFileDetails);
    const loading = useSelector(state => state.vlnFileDteails.loading);
    const [vlnProfileDetails, setVlnProfileDetails] = useState(vlnFileDteails)
    useEffect(() => {
        setVlnProfileDetails(vlnFileDteails)
    }, [vlnFileDteails])
    if (userLogin?.Results[0]?.vln_id_flag === '2') {
        return (
            <div className='file_details' style={lng === 'arab' ? { direction: 'rtl' } : null}>
                <ShareHeader pageName={t("File Details")} noShare={true} />
                <div className='submit_requ_header'>
                    <h3 style={{ color: 'gray' }}>{t("File Details")}</h3>
                </div>
                {loading?
                <Loading height='500px' />:
                <div className='volunteer_portal_lobby_both_sides'>
                    <div className='volunteer_portal_lobby_left_side'>
                        <LocalAidProfileComp icon={icon1} keyOf={t('Number')} value={vlnProfileDetails?.volunteerID} englishFont={true}/>
                        <LocalAidProfileComp icon={icon2} keyOf={t("National ID")} value={vlnProfileDetails?.emiratesID} englishFont={true}/>
                        <LocalAidProfileComp icon={icon3} keyOf={t('Gender')} value={vlnProfileDetails?.gender} englishFont={true}/>
                        <LocalAidProfileComp icon={icon4} keyOf={t('Date of Birth')} value={vlnProfileDetails?.dob} englishFont={true}/>
                        <LocalAidProfileComp icon={icon5} keyOf={t('Nationality')} value={vlnProfileDetails?.country}/>
                    </div>
                    <div className='volunteer_portal_lobby_right_side'>
                        <LocalAidProfileComp icon={icon6} keyOf={t('Education')} value={vlnProfileDetails?.educationLevel}/>
                        <LocalAidProfileComp icon={icon7} keyOf={t('Branch')} value={vlnProfileDetails?.branch}/>
                        <LocalAidProfileComp icon={icon8} keyOf={t('Mobile')} value={vlnProfileDetails?.mobile} englishFont={true}/>
                        <LocalAidProfileComp icon={icon9} keyOf={t('Email')} value={vlnProfileDetails?.email} englishFont={true}/>
                    </div>
                </div>
            }
                
            </div>
        )
    } else {
        window.location.replace("/profile");
    }

}

export default FileDetals
